import { render, staticRenderFns } from "./MetropolitanArea.vue?vue&type=template&id=4324ae24&scoped=true"
import script from "./MetropolitanArea.vue?vue&type=script&lang=js"
export * from "./MetropolitanArea.vue?vue&type=script&lang=js"
import style0 from "./MetropolitanArea.vue?vue&type=style&index=0&id=4324ae24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4324ae24",
  null
  
)

export default component.exports